import React, { Component } from "react"
import { Button, Card, CardBody, Col } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { registerUser, registerUserFailed } from "../../store/auth/register/actions"
import { getDashboardData } from "../../store/dashboard/actions"
import { apiError } from "../../store/auth/login/actions"
import Loader from "react-loader-spinner"
import { setUserPreference } from "../../store/auth/profile/actions"
import {withTranslation} from "react-i18next";
import Tooltip from "../../components/Common/tooltip";
import { montarGraficoVendasCanal } from "./vendas-canal-grafico"

class VendasCanal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      graphType:
        props.preferences && props.preferences.Grafico_Vendas_Canal
          ? props.preferences.Grafico_Vendas_Canal
          : "value",
      canais: {
        'SALAO': props.t('dashboard.lista.valorCanal.SALAO.title'),
        'BALCAO': props.t('dashboard.lista.valorCanal.BALCAO.title'),
        'DELIVERY': props.t('dashboard.lista.valorCanal.DELIVERY.title'),
        'TOTEM': props.t('dashboard.lista.valorCanal.TOTEM.title') }
      }
    }

  static getDerivedStateFromProps(props, current_state) {

    const canaisName = canal => {
      return current_state.canais[canal]
    }
    if (props.dashboardValoresPorCanal) {

      let valoresPeriodo = props.dashboardValoresPorCanal.periodo ? props.dashboardValoresPorCanal.periodo[0] : []

      const { options, series } = montarGraficoVendasCanal({
        valores: valoresPeriodo,
        tipo: current_state.graphType,
        t: props.t,
        nomeCanal: canaisName
      })

      return { ...props, chart_options: options, chart_series: series }
    }

    return props
  }

  componentDidMount() {
    this.props.getDashboardData(this.props.dashboardFilters.periodStart,
        this.props.dashboardFilters.periodEnd,
        this.props.dashboardFilters.companiesId, "valoresPorCanal")
  }

  setGraphType(graphType) {
    this.setState(prevState => ({ ...prevState, graphType }))
    this.props.setUserPreference("Grafico_Vendas_Canal", graphType)
  }

  render() {
    return (
      <React.Fragment>
        <Col xl="6">
          <Card>
            <CardBody>
              <div className="d-flex flex-wrap">
                <h4 className="card-title mb-4"> { this.props.t('dashboard.lista.vendascanal.label') } </h4>
                <Tooltip id='vendasdia' tooltip={ this.props.t('dashboard.lista.vendascanal.tooltip') }></Tooltip>
                <div className="ms-auto">
                  <div className="toolbar d-flex flex-wrap gap-2 text-end">
                    <Button
                      color="light"
                      size="sm"
                      type="button"
                      className={
                        this.state.graphType === "percentual" ? "active" : ""
                      }
                      onClick={ () => this.setGraphType("percentual") }
                    >
                      Em Percentual
                    </Button>
                    <Button
                      color="light"
                      size="sm"
                      type="button"
                      className={
                        this.state.graphType === "value" ? "active" : ""
                      }
                      onClick={ () => this.setGraphType("value") }
                    >
                      Em Valor
                    </Button>
                  </div>
                </div>
              </div>
              { this.props.loadingDashboardValoresPorCanal ||
              !this.state.chart_options ||
              !this.state.chart_series ? (
                <div className="loader-container position-absolute">
                  <Loader
                    type="ThreeDots"
                    color="#556EE6"
                    height={ 80 }
                    width={ 80 }
                  />
                </div>
              ) : (
                <div>
                  <ReactApexChart
                    options={ this.state.chart_options }
                    series={ this.state.chart_series }
                    type="bar"
                    height={ 300 }
                  />
                </div>
              ) }
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    )
  }
}

VendasCanal.propTypes = {
  loadingDashboardValoresPorCanal: PropTypes.any,
  dashboards: PropTypes.any,
  getDashboardData: PropTypes.func
}

const mapStatetoProps = state => {
  const {
    dashboardData,
    loadingDashboardValoresPorCanal,
    dashboardValoresPorCanal
  } = state.Dashboard
  const {
    dashboards,
    preferences,
    dashboardFilters
  } = state.Login
  return {
    dashboardData,
    dashboardFilters,
    dashboards,
    loadingDashboardValoresPorCanal,
    dashboardValoresPorCanal,
    preferences
  }
}

export default withTranslation()(connect(mapStatetoProps, {
  registerUser,
  apiError,
  registerUserFailed,
  getDashboardData,
  setUserPreference
})(VendasCanal))
